import { ApiError } from './api-error.js';
const NETWORK_MESSAGE = 'Could not reach the server. Check your connection and try again.';
export class FetchError extends ApiError {
    name = 'FetchError';
    cause;
    constructor(cause, message = NETWORK_MESSAGE) {
        super({ status: 0, error: 'NetworkError', message });
        this.cause = cause;
    }
}
//# sourceMappingURL=fetch-error.js.map